<template>
  <DefaultLayout>
    <ProfileUserFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('User Profiles') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ profileUsers.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ProfileUserCreateAction cssClass="ms-1" @created="reload" v-if="can('USER_MANAGE') || can('RESPONSIBLE_USER_MANAGE')" />
      </template>
    </ProfileUserFilter>

    <ProfileUserList :pagination="pagination" :profileUsers="profileUsers" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ProfileUserCreateAction from "@/components/profileUser/ProfileUserCreateAction.vue";
import ProfileUserFilter from "@/components/profileUser/ProfileUserFilter.vue";
import ProfileUserList from "@/components/profileUser/ProfileUserList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ProfileUserCreateAction,
    ProfileUserFilter,
    ProfileUserList,
  },
  data() {
    return {
      listPropertyName: 'profileUsers',
      apiResource: `users/profiles`,
      profileUsers: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Local Users'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  created() {
    this.pagination.singlePage = true;
    this.pagination.disabled = false;    
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'externalUserProfile';
    },
  },
};
</script>